'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _jsxFileName = 'src/SureDesignSystem/TextArea/TextArea.js';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _TextAreaModule = require('./TextArea.module.css');

var _TextAreaModule2 = _interopRequireDefault(_TextAreaModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var propTypes = {
  className: _propTypes2.default.string,
  wrapperClassName: _propTypes2.default.string,
  labelClassName: _propTypes2.default.string,
  errorClassName: _propTypes2.default.string,
  label: _propTypes2.default.node.isRequired,
  showLabelAsterisk: _propTypes2.default.bool,
  rows: _propTypes2.default.number,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func,
  touched: _propTypes2.default.bool,
  error: _propTypes2.default.string
};
var defaultProps = {
  className: null,
  wrapperClassName: null,
  labelClassName: null,
  showLabelAsterisk: false,
  value: '',
  rows: 10,
  touched: false,
  error: null
};

function TextArea(_ref) {
  var className = _ref.className,
      wrapperClassName = _ref.wrapperClassName,
      labelClassName = _ref.labelClassName,
      errorClassName = _ref.errorClassName,
      label = _ref.label,
      showLabelAsterisk = _ref.showLabelAsterisk,
      touched = _ref.touched,
      error = _ref.error,
      props = _objectWithoutProperties(_ref, ['className', 'wrapperClassName', 'labelClassName', 'errorClassName', 'label', 'showLabelAsterisk', 'touched', 'error']);

  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)(_TextAreaModule2.default.wrapper, wrapperClassName),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45
    },
    __self: this
  }, _react2.default.createElement('label', {
    className: (0, _classnames2.default)(_TextAreaModule2.default.label, labelClassName),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46
    },
    __self: this
  }, label, showLabelAsterisk && _react2.default.createElement('span', {
    className: _TextAreaModule2.default.labelAsterisk,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48
    },
    __self: this
  }, '*'), _react2.default.createElement('textarea', _extends({}, props, {
    className: (0, _classnames2.default)(_TextAreaModule2.default.input, className),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49
    },
    __self: this
  }))), touched && error && _react2.default.createElement('p', {
    className: (0, _classnames2.default)(_TextAreaModule2.default.error, errorClassName),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52
    },
    __self: this
  }, error));
}

TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;
exports.default = TextArea;